import { takeEvery, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { notification } from 'antd';
import pathToRegexp from 'path-to-regexp';
import isFunction from 'lodash/isFunction';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

import { FETCH, LOGIN } from '../constants/fetch';
import {
  setFetchEntityResponse,
  setFetchEntityLoading,
  setFetchEntityError,
} from '../actions/fetch';
import {
  setUserToken,
  setUserLoading,
  setUserError,
  changeLicenseModal,
} from '../actions/user';
import request from '../utils/request';
import Api from '../api';
import { Path } from '../routes';

export function* fetchSaga(url, options, history) {
  try {
    let response = yield call(request, url, options);

    return response;
  } catch (e) {
    if (e.status === 401) {
      window.localStorage.removeItem('_token');
      history.replace('/login');
    }
    if (e.status === 'licenseExpired') {
      yield put(changeLicenseModal('auto'));
    }
    throw e;
  }
}

export function resolveUrl(url, pathParams = {}, queryParams = {}) {
  let resolvedUrl = pathToRegexp.compile(url)(pathParams);

  if (!isEmpty(queryParams)) {
    resolvedUrl += `?${queryString.stringify(queryParams)}`;
  }

  return resolvedUrl;
}

export function* fetch(history, { payload }) {
  const {
    id,
    url,
    options: { onSuccess, onError, pathParams, queryParams, ...options },
    mapper,
  } = payload;
  try {
    yield put(setFetchEntityLoading(id, true));

    const { method, headers, body, ...restOptions } = options;
    const _token = window.localStorage.getItem('_token');

    let response = yield call(
      fetchSaga,
      resolveUrl(url, pathParams, queryParams),
      {
        method: method,
        headers: {
          Authorization: `Bearer ${_token}`,
          ...headers,
        },
        body,
        ...restOptions,
      },
      history
    );

    if (mapper) {
      response = mapper(response);
    }

    yield put(setFetchEntityResponse(id, response));

    if (isFunction(onSuccess)) onSuccess(response);
  } catch (e) {
    yield put(setFetchEntityError(id, e));
    if (isFunction(onError)) onError(e);
    console.error(e);
  } finally {
    yield put(setFetchEntityLoading(id, false));
  }
}

export function* login({ payload }) {
  const { onError } = payload;

  try {
    yield put(setUserLoading(true));
    const { accessToken: token } = yield call(fetchSaga, Api.LOGIN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload.body),
    });

    if (token) {
      yield put(setUserToken(token));
      window.localStorage.setItem('_token', token);
      yield put(push(Path.DOCS));
    }
  } catch (e) {
    if (isFunction(onError)) onError(e);
    yield put(setUserError(e));
  } finally {
    yield put(setUserLoading(false));
  }
}

export default (history) => [
  takeEvery(FETCH, fetch, history),
  takeEvery(LOGIN, login),
];
